import { Component, OnInit, Injectable, ViewChild, Inject } from '@angular/core';
import { Producto } from '../producto.model';
import { SearchInputComponent } from '../../shared-components/search-input/search-input.component';
import { Subject } from '../../../../node_modules/rxjs/Subject';
import { BackendService } from '../../core/backend.service';
import { Observer } from '../../../../node_modules/rxjs/Observer';
import { Observable } from '../../../../node_modules/rxjs/Observable';
import { OperacionProducto } from './operacion-producto.component';
import { Environment } from '../../../environments/enviroment.model';
import { EnvironmentProvider } from '../../core/browser-providers';
import { ActivatedRoute, Router } from '../../../../node_modules/@angular/router';
import { MatPaginatorIntl } from '../../../../node_modules/@angular/material';
import { UpdateEventService } from '../../shared-services/update-event.service';
import { MediaService } from '../../shared-services/media.service';
import { Subscription } from '../../../../node_modules/rxjs/Subscription';
import { EstadoPedido } from '../../pedido/estado-pedido.model';

interface Filters {
  page: number;
  size: number;
  search?: string;
  sort?: string;
}

interface Page {
  pageIndex: number;
  pageSize: number;
}

@Component({
  selector: 'app-cantidad-total',
  templateUrl: './cantidad-total.component.html',
  styleUrls: ['./cantidad-total.component.scss']
})
@Injectable()
export class CantidadTotalComponent implements OnInit {

  private filters: Filters = {
    page: 0,
    size: 50,
    sort: 'created,desc'
  };

  public showFilters = true;
  isMobile: boolean;

  @ViewChild(SearchInputComponent)
  private searchComponent: SearchInputComponent;

  private getNewPage = new Subject<Filters>();

  public totalItems: number;

  roleFiltersActive = false;
  mostrarResumen = false;
  isLoading = false;

  filtersLoaded = false;
  subscriptions: Subscription[] = [];

  id: number;
  acuerdoId: number;
  producto: Producto;

  operacionList = this.backendService.newSubjectWithoutDistinct<Filters>()
  .switchMap(filters => {
    const usersPromise = this.backendService.get(OperacionProducto, Producto.path + 'pedidos/' + this.id + '/' + this.acuerdoId , filters).toPromise();
    return (async () => {
      this.isLoading = true;
      try {
        const permissions = await usersPromise;
        return permissions;
      } catch (error) {
        return [];
      }
      finally {
        this.isLoading = false;
        this.roleFiltersActive = !(this.filters.search === '' || this.filters.search === undefined);
      }
    })();
  }).share() as Observer<Filters> & Observable<OperacionProducto[]>;

  public EstadoPedido = new EstadoPedido();

  constructor(
    private backendService: BackendService,
    @Inject(EnvironmentProvider) env: Environment,
    private route: ActivatedRoute,
    private paginatorsLabels: MatPaginatorIntl,
    public router: Router,
    protected updateEventService: UpdateEventService,
    private mediaService: MediaService,
  ) { }

  async ngOnInit() {
    this.showFilters = true;
    this.filtersLoaded = true;

    this.route.data.subscribe(data => {
      this.id = data.user.id;
      this.producto = data.user;
    });

    this.route.queryParams.subscribe(queryParams => {
      if (queryParams.acuerdo) {
        this.acuerdoId = queryParams.acuerdo as number;
      } else {
        this.acuerdoId = 0;
      }
    });

    this.subscriptions.push(this.mediaService.isMobile.subscribe(isMobile => {
      this.isMobile = isMobile;
      this.showFilters = !this.isMobile;
    }));

    this.paginatorsLabels.itemsPerPageLabel = 'Filas por página:';

    this.operacionList.subscribe(t => {
      this.isLoading = false;
      this.totalItems = t['totalItems'];
    });

    this.refreshRoleList();
  }

  refreshRoleList() {
    this.operacionList.next(this.getFilters());
  }

  getDefaultFilters() {
    this.filters = {
      page: 0,
      size: 50,
      sort: 'created,desc'
    };
  }

  getFilters() {
    return this.filters;
  }

  onPageChange(page: Page) {
    this.filters.page = page.pageIndex;
    this.filters.size = page.pageSize;
    this.refreshRoleList();
  }

  onSearch(searchText) {
    this.filters.search = 'nombre:' + searchText;
    this.refreshRoleList();
  }

  clearSearch() {
    this.searchComponent.searchBox.value = '';
    this.refreshRoleList();
  }

  onFiltersChanged(event) {
    this.refreshRoleList();
  }

  detallesProducto() {

  }

}



// WEBPACK FOOTER //
// ./src/app/productos/cantidad-total/cantidad-total.component.ts